import { Video } from "@hl/base-components/lib/video";
import { ResizedImage } from "@hl/shared-features/lib/features/image";
import { Carousel } from "@mantine/carousel";
import { Box } from "@mantine/core";

import { SlideProps } from "~components/carousel";
import useMintState from "~hooks/useMintState";

import { StrabismusSlideMenu } from "../custom/Strabismus";
import { useEmbedFlags } from "../embed/customize";

import { getSlideBoxShadow, useSlideStyles } from "./MintCarouselCommon";
import { isVideoUrl } from "./MintSeriesHeader";
import MintedBadge from "./MintedBadge";

const MintCarouselSlide: React.FC<SlideProps> = ({
  imageUrl,
  animationUrl,
  selected,
  imagePlaceholder,
  onImageError,
  minted = null,
  name,
}) => {
  const { isCollectorChoiceMint } = useMintState();
  const { classes, cx } = useSlideStyles({ selected, isMobile: false });
  const flags = useEmbedFlags();
  if (!imageUrl) {
    return null;
  }
  const animation = isVideoUrl(animationUrl ?? "")
    ? animationUrl
    : isVideoUrl(imageUrl)
    ? imageUrl
    : null;

  return (
    <Carousel.Slide className={classes.staticSlide}>
      <Box pos="relative">
        {animation ? (
          <Video
            className={cx([classes.video, classes.mediaItem])}
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={animation} />
          </Video>
        ) : (
          <ResizedImage
            styles={{
              image: {
                border: "0.5px solid rgba(0, 0, 0, 0.1);",
                boxShadow: getSlideBoxShadow(selected),
              },
            }}
            width={"100%"}
            fitSize={360}
            src={imageUrl}
            placeholder={imagePlaceholder}
            withPlaceholder={!!imagePlaceholder}
            onError={onImageError}
          />
        )}

        {(isCollectorChoiceMint || !!onImageError) && minted && <MintedBadge />}
        {flags.strabismusTemplate && <StrabismusSlideMenu name={name} />}
      </Box>
    </Carousel.Slide>
  );
};

export default MintCarouselSlide;
